module.exports = __webpack_public_path__ + "img/hr-stone-furnace.414a21c0.png";